import Parse from "parse";

let invalidated = false;
let validationInFlight = null;

export function markSessionInvalid() {
  invalidated = true;
}

export function isSessionInvalidated() {
  return invalidated;
}

// Active session check used by the router guard. Without this, the first nav
// after an admin lock / poisoned token slips through — nothing has triggered a
// 209 yet, so the flag is still false. Concurrent calls share the in-flight
// fetch so we don't fan out duplicate validations.
export function validateSession() {
  if (invalidated) return Promise.resolve();
  if (validationInFlight) return validationInFlight;
  const user = Parse.User.current();
  if (!user) return Promise.resolve();
  validationInFlight = user
    .fetch()
    .catch((err) => {
      if (err && err.code === Parse.Error.INVALID_SESSION_TOKEN) {
        invalidated = true;
      }
    })
    .finally(() => {
      validationInFlight = null;
    });
  return validationInFlight;
}

const LOGOUT_TIMEOUT_MS = 500;

export async function purgeSession() {
  invalidated = false;
  // Bounded race: the await is load-bearing (Parse needs to null its in-memory
  // currentUser before the next guard tick, otherwise the post-redirect nav
  // re-auths the user back to /feed). The timeout caps a hung network.
  await Promise.race([
    Parse.User.logOut().catch(() => {}),
    new Promise((resolve) => setTimeout(resolve, LOGOUT_TIMEOUT_MS)),
  ]);
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith("Parse/")) localStorage.removeItem(key);
    }
  } catch {
    // storage may be unavailable in private mode
  }
  try {
    sessionStorage.clear();
  } catch {
    // ditto
  }
}
